import { render, staticRenderFns } from "./CardWrapper.vue?vue&type=template&id=4b8a2095&scoped=true&"
var script = {}
import style0 from "./CardWrapper.vue?vue&type=style&index=0&id=4b8a2095&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a2095",
  null
  
)

export default component.exports